import { isEmailValid, isPhoneNumberValidNoCountryCode } from './validator';

export const capitalize = (s: string): string => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const australiaDialCode = '+61';

export const getDialCodeFromNumberOrFallbackToAus = (mobileNumber, pickerData): string => {
  const numberHasDialCode = mobileNumber.includes('+');
  if (!numberHasDialCode) {
    return australiaDialCode;
  }

  const lengthOfNumber = mobileNumber.length;
  const dialCodeLength = lengthOfNumber - 9;
  const dialCode = mobileNumber.slice(0, dialCodeLength);

  const validDialCode = !!pickerData.find((countryData) => countryData.dialCode === dialCode);
  if (!validDialCode) {
    return australiaDialCode;
  }
  return dialCode;
};

const mobileNumberLengthNoLeadingZeroOrDialCode = 9;
const stripDialCode = (mobileNumber) => mobileNumber.slice(-mobileNumberLengthNoLeadingZeroOrDialCode);
const plusURLEncoding = '%2B';
const unEncodedPlusInURL = ' ';

export const parseMobileNumberForTextFieldFromURL = (mobileNumber: string | undefined): string | undefined => {
  if (!mobileNumber || !isPhoneNumberValidNoCountryCode(mobileNumber)) {
    return mobileNumber;
  }

  const formattedFromURL = mobileNumber.replace(plusURLEncoding, '+').replace(unEncodedPlusInURL, '+');

  if (formattedFromURL.includes('+')) {
    return stripDialCode(formattedFromURL);
  }
  const mobileIncludesDialCodeNoPlus = mobileNumber.length > 10;
  if (mobileIncludesDialCodeNoPlus) {
    return stripDialCode(mobileNumber);
  }
  return mobileNumber;
};

export const parseEmailForTextFieldFromURL = (email: string) => {
  if (!email || !isEmailValid(email)) {
    return email;
  }

  const formattedEmail = email.replace(plusURLEncoding, '+').replace(unEncodedPlusInURL, '+');
  return formattedEmail;
};
